module.exports = __webpack_public_path__ + "static/img/light-real.c30453d6.png";